var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("系统管理")]),_c('el-breadcrumb-item',[_vm._v("用户信息")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }